import {IStepEssay} from "../../../interfaces/IStepEssay";
import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../../../App";
import {AppService} from "../../../services/app.service";
import QuizHeader from "./QuizHeader";
import {CardActionArea, IconButton, Snackbar} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

function ReflectiveWriting (p: IStepEssay) {

    const [open, setOpen] = useState<boolean>(false)
    const [alertMsg, setAlertMsg] = useState<string>("")
    const context = useContext(AppContext);
    let questionConfig: any = p.questionConfig;

    const [essayResponse, setEssayResponse] = useState<string>('')

    function saveResponse(weekNo: number, taskNo: number, stepNo: number, response: any) {
        let appService = new AppService();
        let _ = appService.saveQuizResponse(essayResponse, p.id, `${weekNo}${taskNo}${stepNo}`);
        console.log(_);
    }

    function handleAction() {
        if(essayResponse === "") {
            setAlertMsg('Please fill the needed answer to proceed');
            setOpen(true);
        } else {
            console.log('saving response');
            saveResponse(Number(context.currentWeekNo),
                Number(context.currentTaskNo),
                Number(context.currentStepNo),
                essayResponse);
            p.moveNext();
        }
    }

    const handleClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    useEffect(()=> {
        async function getUserData(){
            let appService = new AppService();
            const existing_response = await appService.getQuizResponse(p.id);
            // console.log('response', existing_response.data.payload.saved_response)
            let savedResponse = existing_response.data.payload.saved_response;
            // console.log('saved response', savedResponse)
            if(savedResponse === null || savedResponse === undefined || typeof savedResponse === 'object'){
                setEssayResponse('')
            } else {
                setEssayResponse(savedResponse);
            }
        }
        getUserData();

        return() => {

        }
    },[context.currentStepNo, p.id]);


    return (
        <div className={'reflective-writing'}>
            <QuizHeader question={p.header} customLabel={questionConfig['stepLabel']}/>
            <div className={'question-container'}>
                <div className={'question'}>
                    {p.question}
                </div>
            </div>
            <div className={'writing-section'}>
                <div className={'text-container'}>
                    <textarea  value={essayResponse}
                                onChange={e => {
                                    setEssayResponse(e.target.value);
                                }}/>
                    <span className="highlight"/>
                    <span className="bar"/>
                    <label>{(questionConfig['stepLabel'].includes("Answer")) ? "YOUR ANSWER" : "Your ANSWER" }</label>
                </div>

                <div className={'reflective-action-area'}>
                    <CardActionArea className={'transcript-previous-button'} onClick={p.moveBack}>
                        Previous
                    </CardActionArea>
                    <CardActionArea className={'next-button'} onClick={handleAction}>
                        {/*{(p.buttonLabel) ? p.buttonLabel : "Next"}*/}
                        Next
                    </CardActionArea>
                </div>

            </div>


            <div className={'mobile-spacing'}/>

            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message={alertMsg}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />

        </div>
    )
}

export default ReflectiveWriting;
